/** Team settings for office and advocacy teams (screenshots/119). Admin/owner edit; members see them read-only. */
import type { OrgRole } from "../nav/navConfig";

export interface TeamSettings {
  name: string;
  ward: number | null;                         // offices
  emailDomain: string | null;                  // "@cityofchicago.org" for offices; new members must match
  alertDefaults: { forecastMoves: boolean; liveAlerts: boolean; newFilings: boolean; wardMilestones: boolean };
  digest: { to: "all" | "admins" | "off"; sections: ("tossups" | "filings" | "wardResponses" | "upcoming")[] };
  exportsBy: "admins" | "members";
  publicLinksBy: "owners" | "admins";
  version: number;
}

export const defaultTeamSettings = (name: string, group: "office" | "advocacy", ward: number | null = null): TeamSettings => ({
  name, ward: group === "office" ? ward : null, emailDomain: group === "office" ? "@cityofchicago.org" : null,
  alertDefaults: { forecastMoves: true, liveAlerts: true, newFilings: true, wardMilestones: false },
  digest: { to: "all", sections: ["tossups", "filings", "wardResponses", "upcoming"] },
  exportsBy: "members", publicLinksBy: "admins", version: 1,
});

export const canEditTeam = (role: OrgRole | null) => role === "owner" || role === "admin";

export function teamSettingsProblems(s: TeamSettings): string[] {
  const p: string[] = [];
  if (!s.name.trim()) p.push("Team name can’t be empty.");
  if (s.ward != null && (s.ward < 1 || s.ward > 50)) p.push("Ward must be 1–50.");
  if (s.emailDomain && !/^@[a-z0-9.-]+\.[a-z]{2,}$/i.test(s.emailDomain)) p.push("Email domain looks wrong.");
  return p;
}

/** Can a member with this email join? (Offices are domain-locked.) */
export const emailAllowed = (s: TeamSettings, email: string) => !s.emailDomain || email.toLowerCase().endsWith(s.emailDomain.toLowerCase());
